

























/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Mixins, Vue } from 'vue-property-decorator';
import { ProjectService } from '@store/service/ProjectService';
import PopupMixin from '@mixin/popup';
import UserHeader from '@part/dashboard/UserHeader';
import FaqList from '@part/dashboard/FaqList';
import ProjectList from '@part/dashboard/ProjectList.vue';

/* ----------------------------------------
    Component
---------------------------------------- */

    @Component({
        data() {
            return {
                projects: null,
            };
        },

        components: {
            ProjectList,
            UserHeader,
            FaqList
        },
        
        mixins: [
            PopupMixin,
        ],

        created() {
            this.projectService = new ProjectService(this.$store);
            this.fetchProjects();

            this.$root.$on('root::projects::fetch', () => {
                this.fetchProjects();
            })
        },

        computed: {
            
            hasProjects() {
                if (!this.projects) return false;

                const communityProjectsExists = this.projects.community.length > 0;
                const companyProjectsExists = this.projects.companies
                    .map(company => company.projects.length > 0)
                    .includes(true);
                
                return (communityProjectsExists || companyProjectsExists);
            }
        },

        methods: {
            fetchProjects() {
                this.projectService.getProjectList()
                    .then(response => {
                        if (response instanceof Error)
                            return response;

                        this.projects = response.data;
                    });
            }
        }
    })

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Projects extends Vue {}

